import styled from "styled-components";
import { Space, Button as AntButton } from "antd";
import { IMG_WHEEL_BG, RefreshOutlined } from "@assets";
import { FriendListBg, SpinBG } from "@assets";

export const RootContainer = styled.div`
	position: relative;
	height: 100vh;
	overflow-y: auto;
`;

export const RefreshIcon = styled(RefreshOutlined)`
	font-size: 24px;
	color: #fff;
`;

// export const HeadingBackground = styled.div`
// 	position: absolute;
// 	top: -80px;
// 	left: calc(50% - 311px);
// 	width: 622px;
// 	height: 361px;
// 	border-radius: 50%;
// 	background: linear-gradient(180deg, #fe8a02 0%, #ffec63 100%);
// 	@media screen and (max-height: 670px) {
// 		border-radius: 60%;
// 		top: -120px;
// 	}
// `;

export const TopBgImage = styled.img.attrs({
	alt: "bg-img",
	src: SpinBG,
})`
	position: fixed;
	top: 0;
	width: 100%;
	max-width: 480px;
	z-index: 500;
	height: 210px;

	@media screen and (max-height: 650px) {
		height: 180px;
	}
`;

export const DailyWinnerListContainer = styled.div`
	margin: 291px 0 0 0;
	flex-direction: column;
	align-items: center;

	@media screen and (min-width: 400px) {
		margin: 298px 0 0 0;
	}
`;

export const EmptyTextWrapper = styled.div`
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const EmptyText = styled.div`
	color: #db7802;
	text-align: center;
	font-size: 15px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
`;

export const Heading = styled.div`
	width: 100%;
	max-width: 480px;
	margin: 0 auto auto 0;
	display: flex;
	justify-content: center;
	@media (min-height: 735px) and (max-height: 745px) {
		margin-bottom: 0px;
	}
`;

export const TitleWrapper = styled.div`
	margin: 10px 0 5px;
	background-image: url(${FriendListBg});
	background-repeat: no-repeat;
	background-position: center; /* Center the background image horizontally and vertically */
	background-size: 280px auto;
	display: flex;
	justify-content: center;
	gap: 3px;
	align-items: center;
	width: 280px;
`;

export const Title = styled.p`
	color: #000000;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 50px;
`;

export const Number = styled.div`
	width: 60px;
	height: 69px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-right: 1px solid #f2f1f0;

	color: #342309;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;

	@media screen and (max-height: 670px) {
		font-size: 10px;
		line-height: 10px;
	}
`;

export const Bottom = styled(Space)`
	padding-top: 305px;
	padding-bottom: 16px;
	z-index: 99;
	background-color: ${(props) => props.theme.backgroundColor};
	position: fixed;
	width: 100%;
	max-width: 480px;
	gap: 16px !important;
	justify-content: center;

	.ant-space-item {
		flex: 1;

		:nth-child(1) {
			text-align: right;
			padding-inline-start: 16px;
		}

		:nth-child(2) {
			text-align: left;
			padding-inline-end: 16px;
		}
	}

	.ant-btn {
		width: 100%;
		background-color: #71207c !important;
	}

	@media screen and (max-width: 400px) {
		padding-top: 285px;
	}
`;

export const SpinnerBox = styled.div`
	width: 100%;
	position: sticky;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
`;

export const OuterBadge = styled.img.attrs({
	alt: "badge",
	id: "badge-img",
	src: IMG_WHEEL_BG,
})`
	position: absolute;
	width: 249px;
	height: 249px;
	border-radius: 50%;
	cursor: pointer;
	z-index: 200;
	top: 21px;
	margin-left: 0px;

	@media screen and (max-width: 350px) {
		width: 210px;
		height: 210px;
		margin-left: 0px;
		top: 42px;
	}
	@media screen and (max-height: 650px) {
		width: 190px;
		height: 190px;
		margin-left: -1px;
		top: 15px;
	}
`;

export const WheelContainer = styled.div`
	position: fixed;
	width: 100%;
	max-width: 480px;
	height: 293px;
	z-index: 800;
	display: flex;
	align-items: center;
	justify-content: center;
	top: 35px;

	> div {
		width: 220px;
		height: 220px;
		transform: rotate(-48deg);
	}

	img:not(#badge-img):not(#center) {
		display: none;
	}

	@media screen and (max-width: 350px) {
		> div {
			width: 190px;
			height: 190px;
		}
	}

	@media screen and (max-height: 650px) {
		> div {
			width: 170px;
			height: 170px;
		}
		height: 220px;
	}
`;

export const SpinButton = styled(AntButton)`
	background-color: ${(props) =>
		props.isRule ? "#FFFFFF" : "#0095DA"} !important;
	color: ${(props) => (props.isRule ? "#000000" : "#FFFFFF")} !important;
	font-weight: 400;
	font-size: 16px;
	width: 135px;
	height: 42px;
	display: flex;
	justify-content: center;
	align-items: center;
	&:hover {
		background-color: ${(props) =>
			props.isRule ? "#FFFFFF" : "#0095DA"} !important;
		color: ${(props) => (props.isRule ? "#000000" : "#FFFFFF")} !important;
	}
	@media screen and (max-height: 670px) {
		width: 130px !important;
		height: 37px !important;
		font-size: 14px !important;
	}
`;

export const Container = styled.div`
	position: relative;
	z-index: 999;
	text-align: center;
	margin-top: 350px;

	.ant-btn {
		height: 52px;
		margin-top: 24px;
		max-width: 170px;
	}
`;

export const Text = styled.div`
	padding-bottom: 10px;
	color: black;
	font-size: 18px;
`;

export const SpinWrapper = styled.div`
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	position: relative;
`;

export const WinnersContainer = styled.div`
	width: 88%;
	margin: 0 auto;
	border: 1px solid #e1f0ff;
	border-radius: 26px;
	max-height: 332px;
	position: relative;
	overflow: auto;
	@media (max-height: 1300px) {
		height: 400px;
	}
	@media (max-height: 800px) {
		height: 257px;
	}
	@media (max-height: 734px) {
		height: 193px;
	}
	@media (max-height: 683px) {
		height: 173px;
	}
	@media (max-height: 650px) {
		height: 192px;
	}
`;

export const WinnerItem = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 0 0 1px 0;
	background-color: #fff;
	&:nth-child(odd) {
		background-color: #e1f0ff;
	}
	@media screen and (max-height: 670px) {
		height: 47px;
	}
`;

export const DataContainer = styled.div`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 4px;
	align-items: left;
	padding: 8px 16px;
`;

export const NameAndAmountContainer = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	justify-content: space-between;
	align-items: center;
`;

export const NameWrapper = styled.div`
	color: #000000;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	@media screen and (max-height: 670px) {
		font-size: 10px;
	}
`;

export const PhoneWrapper = styled.div`
	flex-grow: 1;
	text-align: left;
	color: #969696;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 14px; /* 100% */
	@media screen and (max-height: 670px) {
		font-size: 10px;
	}
`;

export const AmountWrapper = styled.div`
	color: #004f9c;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	@media screen and (max-height: 670px) {
		font-size: 10px;
	}
`;

export const BottomContainer = styled.div`
	width: 100%;
	position: relative;
	top: 300px;
	height: -webkit-calc(
		100% - 253px - 40px - 70px
	) !important; /* 100vh - wheel container - button height - top navbar */
	height: -moz-calc(
		100% - 253px - 40px - 70px
	) !important; /* 100vh - wheel container - button height - top navbar */
	height: calc(
		100% - 253px - 40px - 70px
	) !important; /* 100vh - wheel container - button height - top navbar */
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-end;
	text-align: center;

	/* Add vendor prefixes for older browsers */
	@media screen and (max-height: 650px) {
		height: -webkit-calc(
			100% - 253px - 40px - 70px
		) !important; /* Webkit browsers */
		height: -moz-calc(100% - 253px - 40px - 70px) !important; /* Firefox */
		height: calc(100% - 253px - 40px - 70px) !important; /* Standard */
		top: 230px;
	}
	@media screen and (max-height: 430px) {
		top: 240px;
	}
	@media screen and (max-height: 410px) {
		top: 250px;
	}
	@media screen and (max-height: 400px) {
		top: 280px;
	}
`;

export const TableContainer = styled.div`
	margin: 1px auto auto 0px;
	flex-grow: 1;
	z-index: 99;
	position: relative;
	width: 100%;
	max-width: 480px;
	@media screen and (max-height: 683px) {
		height: -webkit-calc(100vh - 450px);
		height: -moz-calc(100vh - 450px); /* Firefox */
		height: calc(100vh - 450px);
	}
`;

export const ButtonWrapper = styled.div`
	width: 300px;
	position: absolute;
	top: 250px;
	left: -webkit-calc(50% - 150px);
	left: -moz-calc(50% - 150px); /* Firefox */
	left: calc(50% - 150px);
	display: flex;
	justify-content: space-between;
	@media screen and (max-height: 650px) {
		top: 180px;
	}
	@media screen and (max-width: 303px) {
		width: 270px;
		left: -webkit-calc(50% - 136px);
		left: -moz-calc(50% - 136px); /* Firefox */
		left: calc(50% - 136px);
	}
`;

export const LoadMoreWrapper = styled.div`
	text-decoration: underline;
	color: #d28a28;
	font-size: 14px;
	font-weight: 100;
	line-height: 17.5px;
	cursor: pointer;
	margin: 10px 0;
`;

export const SpinStartWrapper = styled.div`
	width: 50px !important;
	height: 50px !important;
	border-radius: 50%;
	font-weight: 400 !important;
	font-size: 10px !important;
	color: #ffffff !important;
	position: absolute;
	z-index: 1000;
	transform: rotate(0deg) !important;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
`;